import React from 'react'
import { DropdownContainer } from './styled'
import INFTDropdown from './INFTDropdown'

export default function NFTDropdown({ onChange, options, defaultValue }: INFTDropdown) {
  return (
    <DropdownContainer
      inline
      options={options}
      onChange={(e: any, data: any) => onChange(data.value)}
      defaultValue={defaultValue}
    />
  )
}
